import { useMutation, useQueryClient } from "@tanstack/react-query"
import { cancelRfqBuyerToAdmin, type CancelRfqBuyerToAdminPayload } from "@/lib/api/rfq.api"
import { useAuthStore } from "@/store/auth.store"

export interface CancelRfqBuyerToAdminVariables {
  id: string
  payload: CancelRfqBuyerToAdminPayload
}

export function useCancelRfqBuyerToAdmin() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, payload }: CancelRfqBuyerToAdminVariables) =>
      cancelRfqBuyerToAdmin(id, payload, accessToken!),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ["buyer-rfqs"] })
      queryClient.invalidateQueries({ queryKey: ["buyer-rfq-detail", id] })
      queryClient.invalidateQueries({ queryKey: ["buyer-rfq-status-updates", id] })
    },
  })
}
